export const FETCH_MODULES = 'FETCH_MODULES';
export const FETCH_MODULES_OK = 'FETCH_MODULES_OK';
export const FETCH_MODULES_FAILED = 'FETCH_MODULES_FAILED';

export const ADD_MODULE = 'ADD_MODULE';
export const ADD_MODULE_OK = 'ADD_MODULE_OK';
export const ADD_MODULE_FAILED = 'ADD_MODULE_FAILED';

export const FETCH_MODULE_ID = 'FETCH_MODULE_ID';
export const FETCH_MODULE_ID_OK = 'FETCH_MODULE_ID_OK';
export const FETCH_MODULE_ID_FAILED = 'FETCH_MODULE_ID_FAILED';

export const PATCH_MODULE = 'PATCH_MODULE';
export const PATCH_MODULE_OK = 'PATCH_MODULE_OK';
export const PATCH_MODULE_FAILED = 'PATCH_MODULE_FAILED';

